import { Image as SitecoreImage, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';

import { PartnerDetails } from '@gn-audio/jss-core';

import { EXPERTISE_MAPPING, ExpertiseImageFields } from './constants';

const addExpertiseImages = (
  partnerProgram: string,
  fields: ExpertiseImageFields,
  imageType: 'video' | 'audio',
  images: ImageField[]
): void => {
  if (!partnerProgram) return;

  for (const [expertiseValue, badgeTypes] of Object.entries(EXPERTISE_MAPPING)) {
    if (partnerProgram.includes(expertiseValue)) {
      const imageKey = (badgeTypes[imageType] + 'Image') as keyof ExpertiseImageFields;
      const image = fields[imageKey] as ImageField;

      if (image) {
        images.push(image);
      }
    }
  }
};

export const getPartnerExpertiseImages = (
  partner: PartnerDetails,
  fields: ExpertiseImageFields
): ImageField[] => {
  const { gnh_audiopartnerprogram, gnh_videopartnerprogram } = partner;
  const images: ImageField[] = [];

  if (gnh_videopartnerprogram || gnh_audiopartnerprogram) {
    addExpertiseImages(gnh_videopartnerprogram, fields, 'video', images);
    addExpertiseImages(gnh_audiopartnerprogram, fields, 'audio', images);
  }

  return images;
};

type PartnerDetailsExpertiseProps = {
  partner: PartnerDetails;
  fields: ExpertiseImageFields;
};

export const PartnerDetailsExpertise = ({ partner, fields }: PartnerDetailsExpertiseProps) => {
  const expertiseImages = getPartnerExpertiseImages(partner, fields);

  if (expertiseImages.length === 0) return null;

  return (
    <div className="mb-4">
      <div className="mt-2 flex flex-wrap gap-2">
        {expertiseImages.map((image, index) => (
          <SitecoreImage key={index} field={image} className="max-w-48" />
        ))}
      </div>
    </div>
  );
};

export default PartnerDetailsExpertise;
